export const state = () => ({
  records: [],
  meta: {},
  fetching: false,
});

export const getters = {
  records(state) {
    return state.records;
  },
  meta(state) {
    return state.meta;
  },
  fetching(state) {
    return state.fetching;
  },
};

export const mutations = {
  SET_DATA(state, data) {
    state.records.push(...(data.data || []));
    state.meta = data.meta || {};
  },
  SET_FETCHING(state, fetching) {
    state.fetching = fetching;
  },
  RESET_DATA(state) {
    state.records = [];
    state.meta = {};
    state.fetching = false;
  },
};

export const actions = {
  fetch({ state, commit }, page = 1) {
    const loadedPage = state.meta.current_page || 0;
    if (page === 1 && state.records.length) {
      return Promise.resolve();
    }
    if (page > 1 && page <= loadedPage) {
      return Promise.resolve();
    }
    commit('SET_FETCHING', true);
    return this.$axios
      .$get('/api/orders', { params: { page } })
      .then((resp) => {
        commit('SET_DATA', resp);
      })
      .finally(() => {
        commit('SET_FETCHING', false);
      });
  },
  clear({ commit }) {
    commit('RESET_DATA');
  },
};
